import { render, staticRenderFns } from "./SortManagement.vue?vue&type=template&id=6b54c52a&"
import script from "./SortManagement.vue?vue&type=script&lang=js&"
export * from "./SortManagement.vue?vue&type=script&lang=js&"
import style0 from "./SortManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports